export const kickSequences = [
	[
		255,0,0,0,
		255,0,0,0,
		255,0,0,0,
		255,0,0,0
	],
	[
		255,0,255,0,
		255,0,255,0,
		255,0,255,0,
		255,0,255,0
	],
	[
		255,0,255,0,
		255,0,255,0,
		255,0,255,0,
		255,0,255,255
	],
	[
		0, 255,0,255,
		0, 255,0,255,
		0, 255,0,255,
		0, 255,0,255
	],
	[
		255,0,0,0,
		0,0,0,0,
		255,0,0,0,
		0,0,0,0
	],
	[
		255,0,0,0,
		0,0,0,0,
		0,0,0,0,
		5,50,150,200
	],
	[
		255,155,0,0,
		0,0,0,0,
		255,155,0,0,
		0,0,0,0
	],
	[
		0,255,0,0,
		0,0,0,0,
		0,255,0,0,
		0,0,0,0
	],
	[
		0,255,155,0,
		0,0,0,0,
		0,255,155,0,
		0,0,0,0
	]
]

export const snareSequences = [
	[
		0,0,0,0,
		0,0,255,0,
		0,0,0,0,
		0,0,255,0
	],
	[
		0,255,0,0,
		0,255,0,0,
		0,255,0,0,
		0,255,0,0
	
	],
	[
		0,255,0,0,
		0,255,0,0,
		0,255,205,205,
		255,205,205,255
	
	],
	[
		0,255,0,0,
		0,0,0,255,
		0,255,0,0,
		0,0,0,255
	],	
	[
		0,0,0,0,
		0,10,20,30,
		40,50,60,70,
		80,90,100,110
	],
	[
		0,255,0,0,
		0,0,0,0,
		0,255,0,0,
		0,0,0,0
	]
]

export const clapSequences = [
	[
		0,0,0,0,
		0,0,255,0,
		0,0,0,0,
		0,0,255,0
	]
]

export const drumRollSequence = new Array(16).map( i => i * 255 / 16 )

export const hatSequences = [
	[
		255,0,170,0,
		200,0,170,0,
		255,0,170,0,
		200,0,170,0
	],
	[
		0, 100, 0, 100,
		0, 100, 0, 100,
		0, 100, 0, 100,
		0, 100, 0, 100
	],
	[
		255,0,170,0,
		200,0,170,0,
		255,0,170,0,
		200,0,170,188
	],	
	[
		170,0,0,0,
		170,0,0,0,
		170,0,0,0,
		170,0,0,0
	],
	[
		50,50,50,50,
		50,50,50,50,
		50,50,50,50,
		50,50,50,50
	],
	[
		20,50,20,50,
		20,50,20,50,
		20,50,20,50,
		20,50,20,50
	],
	[
		0,0,0,0,
		0,0,0,0,
		0,0,0,0,
		0,0,0,0
	]
// 	,[
// 		255,180,200,170,
// 		200,180,200,170,
// 		255,180,200,170,
// 		200,180,200,170,
// 	]
]